import { IParameters } from "../types/parametres-type";

export const parametersContants: IParameters[] = [
	{
		id: "Parameter_1",
		parameters: [
			{
				isSelected: true,
				color: "#2E318B",
				id: "parameterOne_windSpeed",
				isDisabled: false,
				key: "wind_speed_10m",
				name: "windSpeedWithoutUnits",
			},
			{
				isSelected: false,
				color: "#B40E0E",
				id: "parameterOne_currentVelocity",
				isDisabled: true,
				key: "current_speed",
				name: "currentVelocityWithoutUnits",
			},
			{
				isSelected: false,
				color: "#00FF88",
				id: "parameterOne_meanWavePeriod",
				isDisabled: false,
				key: "wave_period",
				name: "meanWavePeriodWithoutUnits",
			},
			{
				isSelected: false,
				color: "#F2D202",
				id: "parameterOne_waveHeight",
				isDisabled: false,
				key: "wave_height",
				name: "waveHeightWithoutUnits",
			},
			{
				isSelected: false,
				color: "#A24300",
				id: "parameterOne_seaSurfaceTemperature",
				isDisabled: false,
				key: "sea_surface_temperature",
				name: "seaSurfaceTemperatureWithoutUnits",
			},
			{
				isSelected: false,
				color: "#FF1EB7",
				id: "parameterOne_tideElevation",
				isDisabled: false,
				key: "tidal_elevation",
				name: "tideElevationWithoutUnits",
			},
		],
	},
	{
		id: "Parameter_2",
		parameters: [
			{
				isSelected: false,
				color: "#2E318B",
				id: "parameterTwo_windSpeed",
				isDisabled: true,
				key: "wind_speed_10m",
				name: "windSpeedWithoutUnits",
			},
			{
				isSelected: true,
				color: "#B40E0E",
				id: "parameterTwo_currentVelocity",
				isDisabled: false,
				key: "current_speed",
				name: "currentVelocityWithoutUnits",
			},
			{
				isSelected: false,
				color: "#00FF88",
				id: "parameterTwo_meanWavePeriod",
				isDisabled: false,
				key: "wave_period",
				name: "meanWavePeriodWithoutUnits",
			},
			{
				isSelected: false,
				color: "#F2D202",
				id: "parameterTwo_waveHeight",
				isDisabled: false,
				key: "wave_height",
				name: "waveHeightWithoutUnits",
			},
			{
				isSelected: false,
				color: "#A24300",
				id: "parameterTwo_seaSurfaceTemperature",
				isDisabled: false,
				key: "sea_surface_temperature",
				name: "seaSurfaceTemperatureWithoutUnits",
			},
			{
				isSelected: false,
				color: "#FF1EB7",
				id: "parameterTwo_tideElevation",
				isDisabled: false,
				key: "tidal_elevation",
				name: "tideElevationWithoutUnits",
			},
		],
	},
];
